<div class="ngdialog ts-modal-dialog custom-width ts-confirm-modal-dialog">
    <div class="ngdialog-overlay"></div>
    <div class="ngdialog-content">
        <div class="ts-confirm-modal">
            <div class="analytics-panel">
                <div class="ts-modal-dialog-header">
                    <h5 class="app-font-family-base ts-modal-dialog-title" style="outline: 0px;">{{ 'actions.confirmation' | translate }}
                    </h5>
                    <!-- <i class="ms-Icon ms-Icon--ChromeClose" title="ChromeClose" aria-hidden="true" (click)="dialogeNo()"></i> -->
                    <button class="close-button p-ripple p-element p-dialog-header-icon p-dialog-header-close p-link modal-close-button" (click)="dialogeNo()" [attr.aria-label]="'CLOSE' | translate">
                        <i class="p-dialog-header-close-icon pi pi-times" [title]="'CLOSE' | translate"></i>
                    </button>
                </div>
                <div class="ts-modal-dialog-content">
                    <div class="ts-confirm-dialog-description">{{message}}</div>
                    <div *ngIf="warningMessage" class="ts-confirm-dialog-warning" role="alert">
                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                        <span>{{warningMessage}}</span>
                    </div>
                </div>
                <div class="ts-modal-dialog-footer">
                    <div class="ts-modal-dialog-footer-buttons">
                        <div class="ts-modal-button-div">
                            <button class="ts-btn ts-btn-fluent ts-btn-fluent-white  button-height-1 ts-btn-width-default" (click)="dialogeNo()">{{ 'actions.no' | translate }}</button>
                            <button class="ts-btn ts-btn-fluent-primary ts-btn-fluent button-height-1 ts-btn-width-default" (click)="dialogeYes()">{{ 'actions.yes' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>